import { Box } from '@mui/material';
import { SxClassProps } from '@/types';

const classes: SxClassProps = {
  animationContainer: (theme) => ({
    height: { xs: '205px', md: '255px' },
    width: { xs: '600px', sm: '1050px', md: '1900px' },
    margin: { md: theme.spacing(0, 'auto', 3) },
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  }),
  animation: {
    position: 'absolute',
    top: '0px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',

    '&.animateLeftToRight': {
      left: '0px',
      animation: 'marqueeTop linear infinite',
      animationDuration: {
        xs: '18s',
        sm: '30s',
      },
      '@keyframes marqueeTop': {
        xs: {
          '0%': { transform: 'translateX(0) translateZ(0)' },
          '100%': { transform: 'translateX(-50%) translateZ(0)' },
        },
        sm: {
          '0%': { transform: 'translateX(0) translateZ(0)' },
          '100%': { transform: 'translateX(-33.3%) translateZ(0)' },
        },
      },
    },

    '&.updateDuration': {
      animationDuration: {
        xs: '24s',
      },
    },

    '&.animateRightToLeft': {
      right: '0px',
      animation: 'marqueeBottom linear infinite',
      animationDuration: {
        xs: '18s',
        sm: '30s',
      },
      '@keyframes marqueeBottom': {
        xs: {
          '0%': { transform: 'translateX(0) translateZ(0)' },
          '100%': { transform: 'translateX(50%) translateZ(0)' },
        },
        sm: {
          '0%': { transform: 'translateX(0) translateZ(0)' },
          '100%': { transform: 'translateX(33.3%) translateZ(0)' },
        },
      },
    },
  },
};

const RowAnimation = ({ className, images }: { className: string; images: JSX.Element[] }) => {
  return (
    <Box sx={classes.animationContainer}>
      <Box display="flex" sx={classes.animation} className={className}>
        {images}
      </Box>
    </Box>
  );
};

export default RowAnimation;
